import DataObjectIcon from "@mui/icons-material/DataObject";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useUserAuth } from "../contexts/authContext";
import { CustomPagination } from "../customPagination";
import { ConvertISOToDate } from "../util";
import { JsonDialog } from "./jsonDialog";
import ResponsiveGrid from "../grid/responsiveGrid";

export function AlertVolumeLog() {
    const { handleFailedFetch } = useUserAuth();
    const [data, setData] = useState([]);

    const [jsonOpen, setJsonOpen] = useState(false);
    const [selectedJson, setSelectedJson] = useState({});

    const columns = [
        {
            field: "json",
            headerName: "",
            flex: 1,
            midWidth: 50,
            maxWidth: 50,
            display: "flex",
            renderCell: (params) => {
                return (
                    <IconButton size="medium" onClick={() => handleJsonOpen(params.row)}>
                        <DataObjectIcon />
                    </IconButton>
                );
            }
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 200
        },
        {
            field: "organization",
            headerName: "Org",
            flex: 1,
            minWidth: 50
        },
        {
            field: "flight_name",
            headerName: "Operation",
            flex: 1,
            minWidth: 200
        },
        {
            field: "time_start",
            headerName: "Time Start",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "time_end",
            headerName: "Time End",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "altitude_min",
            headerName: "Altitude AGL (min/max)",
            editable: false,
            minWidth: 150,
            flex: 1,
            valueGetter: (value, row) => `${row.altitude_min_agl_m}/${row.altitude_max_agl_m}`
        },
        {
            field: "deleted",
            headerName: "Deleted",
            minWidth: 75,
            flex: 1
        },
        {
            field: "date_created",
            headerName: "Created",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        },
        {
            field: "date_updated",
            headerName: "Updated",
            minWidth: 175,
            type: "dateTime",
            flex: 1,
            valueFormatter: (value) => `${ConvertISOToDate(value)}`
        }
    ];

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        };

        const fetchData = async () => {
            await fetch("/api/alertVolume/get", requestOptions)
                .then((response) => (response.ok ? response.json() : Promise.reject(response)))
                .then((data) => setData(data))
                .catch((err) => handleFailedFetch(err));
        };
        fetchData();

        return () => setData([]);
    }, []);

    const handleJsonOpen = (row) => {
        setSelectedJson(row);
        setJsonOpen(true);
    };

    return (
        <Box sx={{ height: 578 }}>
            <ResponsiveGrid
                primaryColumns={["name", "json"]}
                disableVirtualization
                rows={data}
                columns={columns}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
                pagination
                slots={{ pagination: CustomPagination }}
                initialState={{ pagination: { paginationModel: { pageSize: 9 } } }}
            />
            {jsonOpen ? <JsonDialog jsonOpen={jsonOpen} setJsonOpen={setJsonOpen} selectedJson={selectedJson}></JsonDialog> : <></>}
        </Box>
    );
}
